export const PHONE = "+263788000111";
export const WHATSAPP = "https://wa.me/263788000111";
export const EMAIL = "sales@accelary.co.zw";
export const ADDRESS = "3 Hunter Rd, New Ardbennie, Harare";
export const LOGO = "/brand/brand/accelary-logo.png";

export const CATEGORIES = [
  { key: "repairs", title: "Repairs & Recovery", tag: "Mechanical & Collision",
    desc: "Panel beating, accident restoration, general repairs & roadside recovery" },
  { key: "detailing", title: "Detailing & Protection", tag: "Ceramic & PPF",
    desc: "Full detailing, paint correction, ceramic coating & paint protection film" },
  { key: "customisation", title: "Customisation & Performance", tag: "Wraps & Tuning",
    desc: "Vinyl wraps, body kits, accessories & tuning diagnostics" },
];
export const CATEGORY_TITLE = Object.fromEntries(CATEGORIES.map((c) => [c.key, c.title]));

const P = "/brand/photos/";
export const BRAND_PHOTOS = [
  "2022-09-05-A0xvek5vrzU2OnMo.avif",
  "2022-11-10-YX4j18vjXvtOJjXa.avif",
  "2023-02-18-Yan06WX0MKcJMvzZ.avif",
  "2020-12-08-Aq2Gel3GowtDa7QW.avif",
  "2022-09-05-1-mp8430Xq8Xf82g5n.avif",
  "2022-11-10-1-Y4LPOyzPxgfngN5p.avif",
  "unnamed-1-Yan06WX0QliNWgP9.avif",
  "unnamed-AQEe80OeJzi5WK5p.avif",
].map((f) => P + f);
export const CATEGORY_PHOTO = { repairs: BRAND_PHOTOS[3], detailing: BRAND_PHOTOS[0], customisation: BRAND_PHOTOS[2] };
export const STOCK = [
  "/brand/stock-reference/photo-1559808632-0959b9514ae1.avif",
  "/brand/stock-reference/photo-1601879324068-a74686b7ba66.avif",
  "/brand/stock-reference/photo-1674510017047-386ae24483b0.avif",
];

export const STATUS_ORDER = [
  "Requested", "Confirmed", "Checked In", "Assessment", "Awaiting Approval",
  "Awaiting Parts", "In Progress", "Quality Check", "Ready for Collection", "Collected",
];
export const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-");

export const VEHICLE_SIZES = [
  ["compact", "Compact / hatchback"], ["sedan", "Sedan"], ["suv", "SUV"],
  ["bakkie", "Bakkie / pickup"], ["large_suv", "Large SUV"], ["van", "Van / minibus"], ["unknown", "Not sure"],
];

export const QUOTE_TYPE = {
  instant: { label: "Instant price", cls: "bg-[#027A48]/10 text-[#027A48] border-[#027A48]/30" },
  range: { label: "Indicative range", cls: "bg-[#B54708]/10 text-[#B54708] border-[#B54708]/30" },
  assessment: { label: "Assessment required", cls: "bg-[#F86900]/10 text-[#B54708] border-[#F86900]/40" },
};
